module.exports = __webpack_public_path__ + "files/23db9b351cb1a503ab4dd70a9a53e520.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/people-1.png
// module id = 1598
// module chunks = 60